<template>
  <div class="mt-2.5 flex flex-col gap-4 pl-20 pt-8">
    <h1 class="text-4xl font-bold">Not found</h1>
    <div class="mt-2.5">
      <div class="mt-2.5 mb-2">You need to use Webinterface-compatible URLs:</div>
      <code class="bg-gp-black p-2 font-mono">/{wiRegion}/server/{controllerSlug}/{server_id}</code>
    </div>
    <div class="mt-2.5">
      <div class="mt-2.5 mb-2">Example:</div>
      <code class="bg-gp-black p-2 font-mono">/eur/server/minecraft-ram/{server_id}</code>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { setTitle } from "../util/title";

onMounted(() => {
  setTitle("Not found");
});
</script>
